import { render, staticRenderFns } from "./InventoryModule.vue?vue&type=template&id=19beef2c"
import script from "./InventoryModule.vue?vue&type=script&lang=js"
export * from "./InventoryModule.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports